/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { ActionButton } from "@octopusdeploy/design-system-components";
import { TextWithLabel as Text } from "@octopusdeploy/design-system-octopus-components";
import type { FormFieldProps } from "@octopusdeploy/design-system-octopus-components";
import { colorScales } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import Dialog from "~/components/Dialog/Dialog";
import { DialogLayout } from "~/components/DialogLayout/DialogLayout";
import styles from "./style.module.less";
interface ColorPickerProps extends FormFieldProps<string> {
    defaultColor?: string;
    id?: string;
    disabled?: boolean;
    label?: string | JSX.Element;
    error?: string;
    warning?: string;
    validate?(value: string): string;
    onValidate?(value: string): void;
}
interface ColorPickerState {
    error?: string;
    pickerOpen: boolean;
}
export default class ColorPicker extends React.Component<ColorPickerProps, ColorPickerState> {
    constructor(props: ColorPickerProps) {
        super(props);
        this.state = {
            pickerOpen: false,
        };
    }
    render() {
        const { id, label, validate, error, onChange, onValidate, defaultColor, value, warning } = this.props;
        const err = this.state.error || error;
        const errorText = err || warning;
        const val = value ? value : "";
        const colorSet1 = [colorScales.red[300], colorScales.orange[300], colorScales.green[300], colorScales.blue[300], colorScales.navy[300], colorScales.purple[300], colorScales.grey[300]];
        const colorSet2 = [colorScales.red[200], colorScales.orange[200], colorScales.green[200], colorScales.blue[200], colorScales.navy[200], colorScales.purple[200], colorScales.grey[200]];
        const cancel = <ActionButton key="CancelButton" label="Cancel" onClick={() => this.setState({ pickerOpen: false })}/>;
        return (<div className={styles.container}>
                <Text id={id} placeholder={defaultColor} value={val} onChange={this.handleChange} error={errorText} label={label}/>
                <a className={styles.colorSwatch} style={{ backgroundColor: val || defaultColor }} onClick={(e) => {
                e.preventDefault();
                this.setState({ pickerOpen: true });
            }}/>
                <Dialog open={this.state.pickerOpen || false}>
                    <DialogLayout actions={[cancel]} title="Standard Palette" closeDialog={() => this.setState({ pickerOpen: false })}>
                        <div>
                            <div className={styles.colorAllOptions}>{colorSet1.map(this.renderPaletteSwatch)}</div>
                            <div className={styles.colorAllOptions}>{colorSet2.map(this.renderPaletteSwatch)}</div>
                        </div>
                    </DialogLayout>
                </Dialog>
            </div>);
    }
    private handleChange = (value: string) => {
        if (this.props.validate) {
            const result = this.props.validate(value);
            this.setState({ error: result });
            if (this.props.onValidate) {
                this.props.onValidate(result);
            }
        }
        this.props.onChange!(value);
    };
    private renderPaletteSwatch = (color: string) => {
        return (<a key={color} className={styles.colorPickItem} style={{ backgroundColor: color }} title={color} onClick={(e) => {
                e.preventDefault();
                this.handleChange(color);
                this.setState({ pickerOpen: false });
            }}/>);
    };
    static displayName = "ColorPicker";
}
